import axios from 'axios';
import { axiosApiInstance } from '../App';
import { url } from './url.service';
const serverUrl = `${url}/productSearches`;

export const getProductSearches = async (date1, date2) => {
  return await axiosApiInstance.get(`${serverUrl}/getByDate/${date1}/${date2}`);
};
